import 'KPackages/runtime-public-path-account'
import { createApp } from 'vue'
import { createKeycloakPlugin } from 'KPackages/vue-plugins/v3/keycloak/keycloak'
import router from './router'
import store from './store'

import App from './App.vue'
import './main.scss'
import '/var/www/packages/css/shared_styles.css'
import '/var/www/packages/css/shared_scss.scss'

const app = createApp(App)
const KeycloakPlugin = createKeycloakPlugin(
  process.env.VUE_APP_ACCOUNT_KEYCLOAK_PUBLIC_CLIENT_ID
)
app.use(KeycloakPlugin);

router.$app = app;
app.use(router)

store.$app = app;
app.use(store)

window.$ = window.jQuery = require('jquery');

const vm = app.mount('#app')
